import { Component, OnDestroy, OnInit, ViewChild,  } from '@angular/core';
import { UploadedorderService } from '../../services/uploadedorder.service';
import { DataTableDirective } from 'angular-datatables';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/startWith';
// import { Observable } from 'rxjs/Observable';
// import { map } from 'rxjs/operators';

// class DataTablesResponse {
//   data: any[];
//   draw: number;
//   recordsFiltered: number;
//   recordsTotal: number;
// }

@Component({
  selector: 'app-uploaded-order',
  templateUrl: './uploaded-order.component.html',
  styleUrls: ['./uploaded-order.component.scss']
})
export class UploadedOrderComponent implements OnInit, OnDestroy {
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  private intervalSubscription: any;
  public prescriptionList = [];
  medicineList = [];
  medicineNames = [];
  sigList =[];
  labTestList =[];
  diagnosticTestList =[];
  specialisationList =[];
  filteredLabTestList =[];
  filteredDiagnosticTestList =[];
  icdCodes =[];
  generatedVisitId: string;


  isCreateOrder: boolean = false;
  isOrderDraft: boolean;
  patientMedicalHistory: any = [];
  isAddSoapNotes: boolean = false;
  isTranscribeOrder: boolean = false;
  dispenseTypes = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Inhaler",
    "Lotion",
    "Creams",
    "Patch",
    "Suppositories",
    "Drops",
    "Lozenge",  
    "Injection",
  ]
  prescriptionForm: FormGroup;
  soapNotesForm: FormGroup;
  labTestForm: FormGroup;
  diagnosticTestForm: FormGroup;

  
  isSlide: boolean = false;
  uploadedOrders = [];
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;

  constructor(private _uploadedorderService: UploadedorderService, private fb: FormBuilder, private router: Router) {  }


  ngOnInit() {
    //this.getUploadedOrders();
    this.getMedicineList();
    this.initializeForms();
    this.getPrescriptionInputMaster()
    this.getDiagnosticTestList();
    this.getAllIcdCodes();
    this.getLabTestList();
    this.getSpecialisationList();

    //auto refresh the uploaded presciptions after every 3 minutes
    this.intervalSubscription = Observable.interval(180000)
    .startWith(0)
    .subscribe(() => {
      this.getUploadedOrders();
      console.log("refresh function called, timer elapsed")
    });
    

  }

  ngOnDestroy(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      console.log("Exit component")
    }
  }

  formatter = (result: string) => result;
  private initializeForms() {
    this.prescriptionForm = this.fb.group({
      drugName: [null, Validators.required],
      dose: ['', Validators.required],
      sig: ['', Validators.required],
      dispenseForm: [this.dispenseTypes[0], Validators.required],
      dispense: [1, [Validators.required, Validators.min(1)]],
      daysSupply: [1, [Validators.required, Validators.min(1)]],
      refills: [0, [Validators.required, Validators.min(0)]],
      pharmacyNotes: [''],
      allowSubstitution: [false] 
    });

    this.soapNotesForm = this.fb.group({
      subjective: [''],
      objective: [''],
      assessment: [''],
      plan: [''],
    });

    this.labTestForm = this.fb.group({
      labTestNotes: [''],
      selectedLabTests: this.fb.array([]) 
      //selectedLabTests: [[]] 
    });

    this.diagnosticTestForm = this.fb.group({
      diagnosticTestNotes: [''],
      selectedDiagnosticTests: this.fb.array([]) 
     
    });
  }

  sideBarToggle() {
    if (this.isSlide) {
        this.isSlide = false;
    }
    else {
        this.isSlide = true;
    }
}
toggleCreateOrder(){
  this.isCreateOrder = !this.isCreateOrder;
}
toggleAddSoapNotes(){

 this.isAddSoapNotes = !this.isAddSoapNotes;
}
toggleTranscribeOrder(){
  this.isTranscribeOrder = !this.isTranscribeOrder;
}
reloadComponent() {
  // Navigate away to a dummy route and back to the current route
  const currentUrl = this.router.url;
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate([currentUrl]);
  });
}

setPrescriptionList() {
  this .prescriptionList = this.uploadedOrders;
  console.log("setPrescriptionList--",this.uploadedOrders);
}

  getUploadedOrders() {
    this._uploadedorderService.getAllUploadedPrescriptions().subscribe(
      data => {
        this.uploadedOrders = data.response.prescriptionRecords;
        console.log(this.uploadedOrders);
        this.prescriptionList = this.uploadedOrders;
      },
      err => {
        console.log(err);
      }
    )
  }
  searchProduct(searchValue) {
    // if (!searchValue || searchValue === '') {
    //   this.prescriptionList = this.uploadedOrders;
    //   return;
    // }
  
    const lowerCaseSearch = searchValue.toLowerCase();
    this.prescriptionList = this.uploadedOrders.filter(prescription => 
      prescription.patientName && 
      prescription.patientName.toLowerCase().includes(lowerCaseSearch)
    );
  }
  filterLabTest(searchValue) {
    // if (!searchValue || searchValue === '') {
    //   this.filteredLabTestList = this.labTestList;
    //   console.log("filteredList---", this.filteredLabTestList)
    //   return;
    // }
  
    const lowerCaseSearch = searchValue.toLowerCase();
    this.filteredLabTestList = this.labTestList.filter(test => 
      test.testName && 
      test.testName.toLowerCase().includes(lowerCaseSearch)
    );
  }

  filterDiagnosticTest(searchValue) {  
    const lowerCaseSearch = searchValue.toLowerCase();
    this.filteredDiagnosticTestList = this.diagnosticTestList.filter(test => 
      test.testName && 
      test.testName.toLowerCase().includes(lowerCaseSearch)
    );
  }

  get selectedLabTests(): FormArray {
    return this.labTestForm.get('selectedLabTests') as FormArray;
  }
  get selectedDiagnosticTests(): FormArray {
    return this.diagnosticTestForm.get('selectedDiagnosticTests') as FormArray;
  }

  onLabCheckboxChange(event: Event, testId: number): void {
    const checkbox = event.target as HTMLInputElement;
    const selectedLabTests = this.selectedLabTests;

    if (checkbox.checked) {
      selectedLabTests.push(this.fb.control(testId));
    } else {
      const index = selectedLabTests.controls.findIndex(x => x.value === testId);
      selectedLabTests.removeAt(index);
    }
  }

  onDiagnosticCheckboxChange(event: Event, testId: number): void {
    const checkbox = event.target as HTMLInputElement;
    const selectedDiagnosticTests = this.selectedDiagnosticTests;

    if (checkbox.checked) {
      selectedDiagnosticTests.push(this.fb.control(testId));
    } else {
      const index = selectedDiagnosticTests.controls.findIndex(x => x.value === testId);
      selectedDiagnosticTests.removeAt(index);
    }
  }


  createOrder(patientID, recordID, isDraft) {
    if(isDraft !== null)
      {
        this.isOrderDraft = false;
      }
      else{
        this.isOrderDraft = true;
      }
    const confirmed = confirm("Create order?");
    if(confirmed){

    this.toggleCreateOrder();
    this._uploadedorderService.getPatientMedicalHistoryByID(patientID).subscribe(
      data => {
        console.log(data);
        this.patientMedicalHistory = data.response.categories;
      },
      err => {
        console.log(err);
      }
    )
    this._uploadedorderService.createPrescriptionAppointment(patientID, recordID).subscribe(
      data => {
        console.log("generated visit id",data)
        this.generatedVisitId = (data as any).response.appointmentDetail.appointmentId;
        console.log("generated id",this.generatedVisitId);
        
      }

    )
  }
    

  }
  addExpandProperty() {
    this.patientMedicalHistory.forEach(category => {
      category.subCategories.forEach(subCategory => {
        subCategory.isExpanded = false;
      });
    });
  }

  addSoapNotes(visitId) {
    // this._uploadedorderService.addSoapNotes(visitId)
    this.toggleAddSoapNotes();
    alert("SOAP notes added successfully");
  }

  getMedicineList(){
    this._uploadedorderService.getMedicineList().subscribe(
      data => {
        console.log("getMedicineList--",data);
        this.medicineList = data.response.medicineList;
        this.medicineNames = this.medicineList.map(medicine => medicine.medicinename);
        console.log("medicine List--", this.medicineList)
      },
      err => {
        console.log(err);
      }
    )
  }
  getPrescriptionInputMaster(){
    this._uploadedorderService.getPrescriptionInputMaster().subscribe(
      data => {
        this.sigList = data.response;
        console.log("prescriptionInputMaster SIG List--", this.sigList)
      },
      err => {
        console.log(err);
      }
    )
  }
  getLabTestList(){
    this._uploadedorderService.getLabTestList().subscribe(
      data => {
        this.labTestList = data.response.laboratoryTestList;
        this.filteredLabTestList = this.labTestList;
        console.log("labTestList List--", this.labTestList)
      },
      err => {
        console.log(err);
      }
    )
  }

  getSpecialisationList(){
    this._uploadedorderService.getDoctorSpecialisationList().subscribe(
      data => {
        this.specialisationList = data.response.specializationList;
        console.log("specialisationList List--", this.specialisationList)
      },
      err => {
        console.log(err);
      }
    )
  }  
  getDiagnosticTestList(){
    this._uploadedorderService.getDiagosticsTestList().subscribe(
      data => {
        this.diagnosticTestList = data.response.laboratoryTestList;
        this.filteredDiagnosticTestList = this.diagnosticTestList;
        console.log("diagnosticTestList List--", this.diagnosticTestList)
      },
      err => {
        console.log(err);
      }
    )
  }

  getAllIcdCodes(){
    this._uploadedorderService.getAllIcdCodes().subscribe(
      data => {
        this.icdCodes = data.response;
        console.log("getAllIcdCodes--",this.icdCodes);
      },
      err => {
        console.log(err);
      }
    )
  }
  publishRecord(){
    this._uploadedorderService.updateDraft(this.generatedVisitId).subscribe(
      data => {
        let returnCode = data.returnCode;
        if(returnCode == 0){
          alert("Record published successfully"); 
          this.reloadComponent();
        }
        else{
          alert("Something went wrong");
        }
      }
    );
    
  }


  onSubmitPrescriptionForm(): void {
    if (this.prescriptionForm.valid) {
      console.log('Prescription Submitted', this.prescriptionForm.value);
      this._uploadedorderService.addPrescription(this.generatedVisitId, this.prescriptionForm.value).subscribe(
        data => {
          let returnCode = data.returnCode;
          console.log(data)
          if(returnCode == 0){
            alert("Prescription added successfully");
            this.prescriptionForm.reset();
          }
          else{
            alert("Something went wrong");
          }
        }
     )
    } else {
      alert('Please fill all required fields');
     }
  }

  onSubmitSoapNotesForm(): void {
    if (this.soapNotesForm.valid) {
      console.log('Soap Notes Submitted', this.soapNotesForm.value);
      this._uploadedorderService.addSoapNotes(this.generatedVisitId, this.soapNotesForm.value).subscribe(
        data => {
          let returnCode = data.returnCode;
          if(returnCode == 0){
            alert("SOAP notes added successfully");
           // this.reloadComponent();
           this.soapNotesForm.reset();
          }
          else{
            alert("Something went wrong");
          }
        }
      )
    } else {
      alert('Please fill all required fields');
    }
  }

  onSubmitLabTestForm(): void {
    if (this.labTestForm.valid) {
      console.log('Lab Test Submitted', this.labTestForm.value);
     this._uploadedorderService.addLabTest(this.generatedVisitId, this.labTestForm.value).subscribe(
       data => {
         let returnCode = data.returnCode;
         if(returnCode == 0){
           alert("Lab test added successfully");
           this.labTestForm.reset();
           
         }
         else{
           alert("Something went wrong");
         }
       }
     )
    } else {
      alert('Please fill all required fields');
    }
  }
  onSubmitDiagnosticTestForm(): void {
    if (this.diagnosticTestForm.valid) {
      console.log('Diagnostic Test Submitted', this.diagnosticTestForm.value);
     this._uploadedorderService.addDiagnosticTest(this.generatedVisitId, this.diagnosticTestForm.value).subscribe(
       data => {
         let returnCode = data.returnCode;
         if(returnCode == 0){
           alert("Diagnostic test added successfully");
           this.diagnosticTestForm.reset();
         }
         else{
           alert("Something went wrong");
         }
       }
     );
    } else {
      alert('Please fill all required fields');
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/admin/uploaded-order/uploaded-order.component.ts